/**
 * ToggleChip
 * Shared toggle chip button for filter popovers.
 * Cream bg when selected, border-only when not.
 */

export function ToggleChip({
  label,
  selected,
  onToggle,
}: {
  label: string
  selected: boolean
  onToggle: () => void
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      onClick={onToggle}
      className={`inline-flex items-center justify-center overflow-hidden p-[10px] rounded-[8px] text-[13px] font-normal leading-[20px] whitespace-nowrap transition-colors ${
        selected
          ? "bg-text-primary text-my-rituality-bg border border-text-primary"
          : "border border-text-primary text-text-primary"
      }`}
    >
      {label}
    </button>
  )
}
